import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  return {
    sw: require('./locales/sw.json'),
    en: require('./locales/en.json')
  };
}

export default createI18n({
  legacy: false,
  locale: localStorage.getItem('app_lang') || 'sw',
  fallbackLocale: 'sw',
  messages: loadLocaleMessages()
});